/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  const collectionJson = document.getElementById('collection_products') ? JSON.parse(document.getElementById('collection_products').innerHTML) : null;
  
  const findMaxDiscountPercentageById = (productId) => {
    if (collectionJson.length) {
      const product = collectionJson.find(p => p.id === productId);
    
      if (!product) return null;
      
      let maxDiscountPercentage = 0;
      let maxDiscountVariant = null;
      
      product.variants.forEach(variant => {
        if (variant.compare_at_price && variant.price) {
          const discountAmount = variant.compare_at_price - variant.price;
          const discountPercentage = (discountAmount / variant.compare_at_price) * 100;
          
          if (discountPercentage > maxDiscountPercentage) {
            maxDiscountPercentage = discountPercentage;
            maxDiscountVariant = variant;
          }
        }
      });
      
      if (maxDiscountVariant) {
        return (Math.round(maxDiscountPercentage * 100) / 100).toFixed(0);
      } else {
        return null;
      }
    }
    return null;
  }

  function getDiscountFromMetafield(product, position) {
    var quantityAndDiscountList = product.productQuantityAndDiscount || [];
    if (typeof quantityAndDiscountList === 'string') {
      try { quantityAndDiscountList = JSON.parse(quantityAndDiscountList); } catch(e) { quantityAndDiscountList = []; }
    }
    if (Array.isArray(quantityAndDiscountList) && quantityAndDiscountList.length > 0) {
      var item = position === 'first'
        ? quantityAndDiscountList[0]
        : quantityAndDiscountList[quantityAndDiscountList.length - 1];
      if (item.discount && item.discount.match(/\d+/)) {
        return parseFloat(item.discount.match(/\d+/)[0]);
      }
    }
    return null;
  }
  
  function getMinimumQuantity(product) {
    return product.minimumQuantity || 1;
  }

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<span>' + formatPrice(price) + '</span>';
    if (comparing) {
      res =
        '<span class="price-with-sale-plp">' + formatPrice(price) + '</span>' +
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      
        
        
        
        
        
    }
    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      var min = this.variants_min_price;
      var max = this.variants_max_price;
      var compareAt = this.compare_at_price;
      var minimumQty = this.minimumQuantity || 1;
      var discountPercent = getDiscountFromMetafield(this, 'first');
      
      // Calculate base price with discount if applicable
      var priceToShow = min;
      if (discountPercent) {
        priceToShow = min - (min * discountPercent / 100);
      }
      
      // Multiply by minimum quantity AFTER discount
      priceToShow = priceToShow * minimumQty;
      if (compareAt) {
        compareAt = compareAt * minimumQty;
      }
      
      if (this._distinct && compareAt) {
        if (min !== max) {
          return '<span class="ais-hit--price-striked">' + formatPrice(compareAt) + '</span><span class="price-with-sale-plp">Starting at <b>' + formatPrice(priceToShow) + '</b></span>';
        }
      }
      if (this._distinct) {
        if (min !== max) {
          return '<span>Starting at <b>' + formatPrice(priceToShow) + '</b></span>';
        }
      }
      return formattedPriceWithComparison(priceToShow, compareAt);
    },
    instantsearchPrice: function instantsearchPrice() {
      var min = this.variants_min_price;
      var max = this.variants_max_price;
      var compareAt = this.compare_at_price;
      var priceToShow = min;
      var minimumQty = this.minimumQuantity || 1;
      
      var discountPercent = getDiscountFromMetafield(this, 'first');
      if (discountPercent) {
        priceToShow = min - (min * discountPercent / 100);
      }
      
      priceToShow = priceToShow * minimumQty;
      if (compareAt) {
        compareAt = compareAt * minimumQty;
      }
      
      var priceHtml = '';
      if (this._distinct && compareAt) {
        if (min !== max) {
          priceHtml = '<span class="ais-hit--price-striked">' + formatPrice(compareAt) + '</span><span class="price-with-sale-plp">Starting at <b>' + formatPrice(priceToShow) + '</b></span>';
        }
      }
      if (!priceHtml && this._distinct) {
        if (min !== max) {
          priceHtml = '<span>Starting at <b>' + formatPrice(priceToShow) + '</b></span>';
        }
      }
      if (!priceHtml) {
        priceHtml = formattedPriceWithComparison(priceToShow, compareAt, this.price_ratio);
      }
      return priceHtml;
    },
    upToText: function upToText() {
      const discountPercent = getDiscountFromMetafield(this, 'last');
      if (discountPercent) {
        return `<p>Up to ${discountPercent}% OFF</p>`;
      }
      const discount = findMaxDiscountPercentageById(this.id);
      if (discount) {
        return `<p>Up to ${discount}% OFF</p>`;
      }
      return;
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    simpleTitle: function simpleTitle() {
      return this.title;
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    }
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);

